type TrackinglistElemProps = {
  name: string;
  value: string;
  last?: boolean;
};

export const TrackingListElem = ({ name, value, last }: TrackinglistElemProps) => {
  return (
    <div className={`flex w-full flex-row ${last ? "" : "border-b"} border-gray-200 py-4`}>
      <span className="flex-1 text-xs font-medium text-gray-600">{name}</span>
      <span className="flex-1 text-sm font-medium text-gray-700">{value}</span>
    </div>
  );
};
